export default "__VITE_ASSET__C8tQQ4JC__"